import { UseMutationResult } from '@tanstack/react-query';
import { QueueSheetManagementRows } from '../interface/QueueSheetInterface';
import { ApiResponseKeys } from '../../../../Shared/interfaces/ApiResponse';
import { ApiError } from '../../../../Shared/interfaces/ApiError';

export const cancelBookingUtils = (
    setIsCancelModalOpen: (isOpen: boolean) => void,
    setBookingToCancel: (booking: QueueSheetManagementRows | null) => void,
    bookingToCancel: QueueSheetManagementRows | null,
    cancelBookingMutation: UseMutationResult<
        ApiResponseKeys,
        ApiError,
        string,
        unknown
    >
) => {
    const handleOpenCancelModal = (booking: QueueSheetManagementRows) => {
        setBookingToCancel(booking);
        setIsCancelModalOpen(true);
    };

    const handleCloseCancelModal = () => {
        setIsCancelModalOpen(false);
        setBookingToCancel(null);
        cancelBookingMutation.reset();
    };

    const handleConfirmCancelBooking = () => {
        if (bookingToCancel?.bookingId) {
            cancelBookingMutation.mutate(bookingToCancel.bookingId);
        }
    };

    return {
        handleOpenCancelModal,
        handleCloseCancelModal,
        handleConfirmCancelBooking,
    };
};
